import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  style: {"z-index":"49"},
  class: "fixed top-0 left-0 flex items-center justify-center w-full h-full"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100% !important","height":"100% !important"},
  class: "absolute z-10 w-full h-full transition-none bg-gray-900 opacity-50"
}, null, -1)
const _hoisted_4 = { class: "fixed z-50 w-full px-6 py-4 text-center transform -translate-x-1/2 -translate-y-1/2 rounded md:w-max top-1/2 left-1/2 md:ml-14" }
const _hoisted_5 = {
  style: {"font-size":"10rem"},
  class: "opacity-50 material-icons-outlined text-lightText"
}
const _hoisted_6 = { class: "flex w-full" }
const _hoisted_7 = { class: "mb-0" }
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = { class: "flex flex-col mb-12" }
const _hoisted_10 = { class: "ml-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-lg text-muted"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "edit", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "done", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons" }, "close", -1)
const _hoisted_16 = {
  key: 1,
  class: "mt-8 banner banner-light"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-400 material-icons-outlined" }, " lightbulb ", -1)
const _hoisted_18 = { class: "flex flex-col w-full space-y-2 md:items-center md:space-y-0 md:flex-row" }
const _hoisted_19 = { class: "mr-2 lg:mr-0" }
const _hoisted_20 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloudSaveStatus = _resolveComponent("CloudSaveStatus")!
  const _component_EventMetaEditor = _resolveComponent("EventMetaEditor")!
  const _component_NumberInput = _resolveComponent("NumberInput")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_EventTemplateEditor = _resolveComponent("EventTemplateEditor")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_EventInstancesPreview = _resolveComponent("EventInstancesPreview")!
  const _component_EventStateEditor = _resolveComponent("EventStateEditor")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_AnnouncementNodeEditor = _resolveComponent("AnnouncementNodeEditor")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "fade-delay" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.examLocked ? "lock" : "lock_open"), 1),
            _createElementVNode("h3", {
              class: _normalizeClass([[!_ctx.examLocked ? 'opacity-0' : 'opacity-100'], "pt-1 mx-auto rounded-t md:bg-transparent text-lightText md:px-2"]),
              style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
            }, _toDisplayString(_ctx.$t("event_editor.currently_locked_by")) + " " + _toDisplayString(_ctx.modelValue?.locked_by?.full_name), 3),
            _createElementVNode("p", {
              class: _normalizeClass([[!_ctx.examLocked ? 'opacity-0' : 'opacity-100'], "pb-1 rounded-b md:bg-transparent text-lightText md:mx-2 md:px-2"]),
              style: {"text-shadow":"0.5px 0.5px 4px rgb(0 0 0 / 50%)"}
            }, _toDisplayString(_ctx.$t("event_editor.lock_stand_by")), 3)
          ])
        ], 512), [
          [_vShow, !_ctx.loading && _ctx.examLocked]
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("event_editor.editor_title")), 1),
      _createVNode(_component_CloudSaveStatus, {
        class: "ml-auto",
        saving: _ctx.saving,
        hadError: _ctx.savingError
      }, null, 8, ["saving", "hadError"])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_EventMetaEditor, {
        modelValue: _ctx.modelValue,
        class: "mb-12",
        onUpdateEvent: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onChange($event.field, $event.value))),
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onBlur()))
      }, null, 8, ["modelValue"]),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_EventTemplateEditor, {
              key: 0,
              class: "",
              randomRuleOrder: _ctx.modelValue.randomize_rule_order,
              modelValue: _ctx.modelValueTemplate,
              showEditWarning: 
						_ctx.modelValue.state === _ctx.EventState.OPEN ||
						_ctx.modelValue.state === _ctx.EventState.RESTRICTED
					,
              onTemplateChanged: _cache[4] || (_cache[4] = ($event: any) => (_ctx.invalidateExamples())),
              onSaving: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saving = true)),
              onDoneSaving: _cache[6] || (_cache[6] = ($event: any) => (_ctx.saving = false))
            }, {
              afterRules: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("event_editor.max_grade")), 1),
                _createElementVNode("div", _hoisted_10, [
                  (!_ctx.editingMaxScore)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.computedMaxScore), 1))
                    : (_openBlock(), _createBlock(_component_NumberInput, {
                        key: 1,
                        modelValue: _ctx.dirtyMaxScore,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dirtyMaxScore) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("event_editor.max_grade")), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue"]))
                ]),
                (!_ctx.editingMaxScore)
                  ? (_openBlock(), _createBlock(_component_Btn, {
                      key: 0,
                      variant: 'icon',
                      outline: true,
                      class: "hidden ml-2",
                      onClick: _ctx.onEditMaxScore
                    }, {
                      default: _withCtx(() => [
                        _hoisted_12
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createVNode(_component_Btn, {
                        variant: 'icon',
                        outline: true,
                        class: "ml-2",
                        onClick: _ctx.onSaveMaxScore
                      }, {
                        default: _withCtx(() => [
                          _hoisted_14
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Btn, {
                        variant: 'icon',
                        outline: true,
                        class: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.editingMaxScore = false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_15
                        ]),
                        _: 1
                      })
                    ]))
              ]),
              _: 1
            }, 8, ["randomRuleOrder", "modelValue", "showEditWarning"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Toggle, {
          class: "mt-3 md:ml-auto md:-mt-7.5",
          "label-on-left": true,
          modelValue: _ctx.modelValue.randomize_rule_order,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.onChange('randomize_rule_order', $event)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("event_template_editor.randomize_rule_order")), 1)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (_ctx.usedRandomization)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("event_editor.tip_you_used_randomization")), 1),
                _createVNode(_component_Btn, {
                  class: "w-full md:w-1/2 -mr-3 lg:-mr-2 lg:w-max md:ml-auto",
                  outline: true,
                  onClick: _ctx.getInstances,
                  disabled: _ctx.loadingExamples
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.loadingExamples
									? _ctx.$t("event_editor.generating_examples")
									: _ctx.$t("event_editor.generate_examples")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _createVNode(_component_EventInstancesPreview, {
                onHide: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showInstancesDialog = false)),
                show: _ctx.showInstancesDialog,
                instances: _ctx.instances
              }, null, 8, ["show", "instances"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_EventStateEditor, {
        loading: _ctx.updatingState,
        class: "pb-10",
        modelValue: _ctx.modelValue,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.onStateUpdate($event.value, $event.fireIntegrationEvent)))
      }, null, 8, ["loading", "modelValue"])
    ]),
    _createVNode(_component_Dialog, {
      yesText: _ctx.$t('misc.edit'),
      noText: _ctx.$t('dialog.default_cancel_text'),
      showDialog: _ctx.showConfirmationDialog,
      warning: true,
      onYes: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showConfirmationDialog = false)),
      onNo: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'CourseExams', params: { courseId: _ctx.courseId } })))
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.editing_open_event_title")), 1)
      ]),
      body: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("event_editor.editing_open_event_body")), 1)
      ]),
      _: 1
    }, 8, ["yesText", "noText", "showDialog"]),
    _createVNode(_component_Dialog, {
      class: "transition-all duration-100 ease",
      showDialog: _ctx.showBlockingDialog,
      onNo: _cache[16] || (_cache[16] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
      onYes: _cache[17] || (_cache[17] = ($event: any) => {
				_ctx.bounceDialog = true;
				_ctx.showAnnouncementEditor = true;
			}),
      large: _ctx.showAnnouncementEditor,
      showActions: !_ctx.showAnnouncementEditor,
      loading: _ctx.publishingAnnouncement,
      dialogBoxClasses: _ctx.bounceDialog ? 'bounce-big-enter-active' : '',
      onAnimationend: _cache[18] || (_cache[18] = ($event: any) => (_ctx.bounceDialog = false))
    }, {
      body: _withCtx(() => [
        _createVNode(_Transition, { name: "fade-quick" }, {
          default: _withCtx(() => [
            (_ctx.showAnnouncementEditor)
              ? (_openBlock(), _createBlock(_component_AnnouncementNodeEditor, {
                  key: 0,
                  modelValue: _ctx.announcement,
                  onPatchNode: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onAnnouncementNodeChange($event.key, $event.value, !!$event.save))),
                  onSave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.resolveBlockingDialog(true))),
                  onCloseEditor: _cache[14] || (_cache[14] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
                  isExistingNode: false,
                  publishOnly: false
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        (!_ctx.showAnnouncementEditor)
          ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.$t("event_editor.publish_announcement_prompt")), 1))
          : _createCommentVNode("", true)
      ]),
      footerButtons: _withCtx(() => [
        _createVNode(_component_Btn, {
          class: "ml-2",
          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.rejectBlockingDialog())),
          variant: 'primary-borderless'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("dialog.default_cancel_text")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["showDialog", "large", "showActions", "loading", "dialogBoxClasses"])
  ]))
}